// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"285":"588f0a9e","709":"f815e575"}[chunkId] + ".chunk.js";
};